export const setUserPreferenceState = preferences => {
  return {
    type: 'USER_PREFERENCES_SET',
    payload: preferences
  }
}

export const setUserPreferences = (settings) => (dispatch, getState) => {
  // const updated = Object.assign(getState().userPreferences, settings)
  dispatch(setUserPreferenceState(settings))
}